import { render, staticRenderFns } from "./ChangePasswordView.vue?vue&type=template&id=121dc40d&scoped=true&"
import script from "./ChangePasswordView.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordView.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordView.vue?vue&type=style&index=0&id=121dc40d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121dc40d",
  null
  
)

export default component.exports